export default __webpack_public_path__ + "static/media/about-video-bg2.9d9f5c52.png";